export default __webpack_public_path__ + "static/media/slider-2.c4a12454.jpg";